module.exports = __webpack_public_path__ + "assets/vocalClarity.1a1d048b.svg";